import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnClipboardTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M15.556 4.907C18.516 5.067 20 6.16 20 10.223v5.333c0 3.555-.889 5.333-5.333 5.333H9.333C4.89 20.89 4 19.111 4 15.556v-5.333c0-4.054 1.484-5.156 4.444-5.316m1.13 8.348 1.3 1.334 3.467-3.559m-4.119-4.363h3.556c1.777 0 1.777-.889 1.777-1.778 0-1.778-.888-1.778-1.777-1.778h-3.556c-.889 0-1.778 0-1.778 1.778s.89 1.778 1.778 1.778"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnClipboardTick;
